module.exports = __webpack_public_path__ + "static/media/Mental_Control_Reinforcement.fefcba81.mp3";